import {BASE_API_URL} from '@env';
import {useQuery} from 'react-query';
import {useUserStore} from '~providers/userStore/zustand';

export interface OrderFinalAddressResponse {
  final_address: string;
}

export const useGetOrderFinalAddress = (order_id: string) => {
  return useQuery<OrderFinalAddressResponse, Error>(
    ['orderFinalAddress', order_id],
    async () => {
      const token = useUserStore.getState().token;

      
        console.log(order_id, token, 'finalAddressDatafinalAddressData');
      const response = await fetch(`${BASE_API_URL}orders/${order_id}/final-address`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
      });

      if (!response.ok) {
        throw new Error(`Failed to get order final address: ${response.status}`);
      }

      const data = await response.json();
      return data;
    },
    {
      enabled: !!order_id,
      staleTime: 5 * 60 * 1000, // Cache for 5 minutes
      cacheTime: 10 * 60 * 1000, // Keep in cache for 10 minutes
    },
  );
};